import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styles from './message-chat.module.scss';
import clsx from 'clsx';
import { ClockIcon } from '@/assets/icons';
import { Typography } from '@/ui-kit';

export const SkeletonMessageChat: React.FC = () => {
    return (
        <div className={styles.messageChat}>
            {/* Скелетон для аватара */}
            <div className={
                clsx(
                    styles.avatar,
                    styles['avatar--expired']
                )
            }>
                <Skeleton
                    circle={true}
                    height={61}
                    width={61} />
            </div>
            <div className={styles.wrapInfo}>
                <div className={styles.info}>
                    {/* Скелетон для имени и возраста */}
                    <Skeleton
                        width={120}
                        height={16}
                    />
                    {/* Скелетон для времени */}
                    <Skeleton
                        width={30}
                        height={12}
                    />
                </div>
                <div className={styles.messageInfo}>
                    {/* Скелетон для последнего сообщения */}
                    <Skeleton
                        width={80}
                        height={14}
                    />
                    {/* Скелетон для количества новых сообщений */}
                    <Skeleton
                        width={20}
                        height={20}
                        circle
                    />
                </div>
            </div>
        </div>
    );
};
